export default function (nga, admin) {

    let entity = admin.getEntity('company')
        .updateMethod('patch')
        .label('company')
        .url(function(entity, view, id) {
            if(id)
                return 'user/' + encodeURIComponent(id);

            return 'user';
        });


    entity.listView()
        .fields([
            nga.field('id').label('ID').isDetailLink(true).detailLinkRoute('show'),
            nga.field('name').label('COMPANY').isDetailLink(true).detailLinkRoute('show'),
            nga.field('subscription').label('SUBSCRIPTION').sortable(false),
            nga.field('last', 'date').label('LAST_ASSINGED').format('yyyy-MM-dd').sortable(false)
        ])
        .listActions(['show', 'edit', 'delete'])
        .sortDir('asc')
        .url('companies')
        .title('Companies')
        .prepare(['Restangular', 'datastore', 'entries', 'Entry', function (Restangular, datastore, entries, Entry) {
            return  Restangular
                .all('subscriptions')
                .getList()
                .then(function(data) {
                    data = data.data ? data.data : data;

                    entries.forEach(function (u, i) {
                        u.values.sub_active = [];
                        u.values.sub_unactive = [];
                        u.values.last = null;

                        data.forEach(function (s, si) {
                            if (s.purchaseUser && u.values.id == s.purchaseUser.id) {
                                if(!s.user && !s.finalize){
                                    u.values.sub_unactive.push(s);

                                }else if(!s.finalize || (new Date(s.finalize)).getTime() >= (new Date()).getTime()){
                                    u.values.sub_active.push(s);
                                }

                                if(!u.values.last || s.updated > u.values.last){
                                    u.values.last = s.updated;
                                }
                                if(u.values.sub_active.length && (!u.values.last || s.created > u.values.last)){
                                    u.values.last = s.created;
                                }
                            }
                        });

                        u.values.subscription = u.values.sub_active.length + " / "+  u.values.sub_unactive.length;
                    });

                    return true;
                });
    }])


    let fields = [
        nga.field('username').label('COMPANY'),
        nga.field('email', 'email').label('EMAIL'),
        nga.field('name').label('NAME'),
        nga.field('surname').label('SURNAME'),
        nga.field('enabled', 'boolean').label('ENABLED')
    ];

    if(HasRole('admin')){
        fields.push(nga.field('created', 'date').label('CREATED').format('yyyy-MM-dd'));
        fields.push(nga.field('roles').label('ROLES'));

        fields.push(
            nga.field('prescriber')
                .map(function (value, entry) {
                    if (entry['prescriber.name'])
                        return entry['prescriber.name'] + ' ' + (entry['prescriber.surname'] ? entry['prescriber.surname'] : '');
                })
                .template('<entity-show type="\'user\'" id="entry.values[\'prescriber.id\']" text="value"></entity-show>')
                .label('PRESCRIBER')
                .cssClasses(function (entry) {
                    if (!entry.values.prescriber)
                        return 'hidden';
                })
        );
        fields.push(
            nga.field('company')
                .map(function (value, entry) {
                    if (entry['company.name'])
                        return entry['company.name'] + ' ' + (entry['company.surname'] ? entry['company.surname'] : '');
                })
                .template('<entity-show type="\'user\'" id="entry.values[\'company.id\']" text="value"></entity-show>')
                .label('COMPANY')
        );
        fields.push(
            nga.field('workers', 'referenced_list')
                .label('WORKERS')
                .targetEntity(nga.entity('user').url('users'))
                .targetReferenceField('company')
                .targetFields([
                    nga.field('id').label('ID'),
                    nga.field('name').label('NAME').isDetailLink(true),
                    nga.field('surname').label('COMPANY').isDetailLink(true),
                ])
        );
        fields.push(
            nga.field('patients', 'referenced_list')
                .label('PATIENTS')
                .targetEntity(nga.entity('user').url('users'))
                .targetReferenceField('prescriber')
                .targetFields([
                    nga.field('id').label('ID'),
                    nga.field('name').label('NAME').isDetailLink(true),
                    nga.field('surname').label('SURNAME').isDetailLink(true),
                ])
        );

        fields.push(nga.field('cif').label('CIF'));
        fields.push(nga.field('address').label('ADDRESS'));
        fields.push(nga.field('city').label('CITY'));
        fields.push(nga.field('postal_code').label('POSTAL_CODE'));
        fields.push(nga.field('state.name').label('STATE'));

    }
    if(HasRole('company')){
        fields.push(
            nga.field('prescriber_type.description')
                .label('PRESCRIBER_TYPE'),
        );
        fields.push(
            nga.field('patients', 'referenced_list')
                .label('PATIENTS')
                .targetEntity(nga.entity('user').url('users'))
                .targetReferenceField('prescriber')
                .targetFields([
                    nga.field('id').label('ID'),
                    nga.field('name').label('NAME').isDetailLink(true),
                    nga.field('surname').label('SURNAME').isDetailLink(true),
                ])
        );
    }
    if(HasRole('prenscriptor')){
        fields.push(nga.field('birthday', 'date').label('BIRTHDAY').format('yyyy-MM-dd'));
        fields.push(
            nga.field('training_time')
                .label('TRAINING_TIME_MIN')
        );
        fields.push(
            nga.field('training_date', 'date')
                .format('yyyy-MM-dd')
                .label('TRAINING_TIME')
        );
        fields.push(
            nga.field('abilities', 'reference_many').label('ABILITIES')
                .targetEntity(nga.entity('ability').url('abilities'))
                .targetField(nga.field('name'))
                .singleApiCall(ids => null)
                .map(function(value, entry){
                    if(entry.formatedAB)
                        return entry.formatedAB;

                    return entry.formatedAB = value.map(function(ability){
                        return ability.ability;
                    });
                })
        );
    }


    entity.showView().fields(fields)
        .prepare(['Restangular', 'datastore', function(Restangular, datastore){
            if(HasRole('admin', 'superadmin')) return false;

            return Restangular
                .all('licences')
                .getList()
                .then(data => {
                    data = data.data ? data.data : data;

                    let licences_pro = [];

                    data.forEach(function(licence, index){
                        if(licence.type == 'gold'){
                            licences_pro.push(licence);
                        }
                    });

                    if(!licences_pro.length){
                        let fields = this.fields();
                        let remove = [];

                        fields.forEach(function(field, index){
                            if (['training_time', 'training_date', 'abilities'].indexOf(field._name) !== -1) {
                                remove.push(index);
                            }
                        });

                        remove.reverse().forEach(function(index, i){
                            fields.splice(index, 1);
                        });
                    }
                });
        }]);


    fields = [
        nga.field('username').label('USERNAME'),
        nga.field('email', 'email') .label('EMAIL'),
        //nga.field('plainPassword', 'password').label('PASSWORD'),
        nga.field('name').label('NAME'),
        nga.field('surname').label('SURNAME'),
        nga.field('enabled', 'boolean').label('ENABLED')
            .template('<ma-switch-field field="::field" value="value" entry="::entry"></ma-switch-field>')
    ];

    if(HasRole('admin')){
        fields.push(nga.field('roles', 'choice').label('ROLES')
            .choices([
                {label: 'COMPANY', value: 'ROLE_COMPANY'},
                {label: 'PRENSCRIPTOR', value: 'ROLE_PRENSCRIPTOR'},
                {label: 'PATINET', value: 'ROLE_PATIENT'}
            ]));
        fields.push(
            nga.field('prescriber', 'reference').label('PRESCRIBER')
                .map(function truncate(value, entry) {
                    return entry['prescriber.id'];
                })
                .targetEntity(nga.entity('user').url('users'))
                .targetField(nga.field('name'))
        );
        fields.push(
            nga.field('company', 'reference').label('COMPANY')
                .map(function truncate(value, entry) {
                    return entry['company.id'];
                })
                .targetEntity(nga.entity('company').url('companies'))
                .targetField(nga.field('name'))
        );


        fields.push(nga.field('cif').label('CIF'));
        fields.push(nga.field('address').label('ADDRESS'));
        fields.push(nga.field('city').label('CITY'));
        fields.push(nga.field('postal_code').label('POSTAL_CODE'));
        fields.push(nga.field('state', 'reference').label('STATE')
            .map(function truncate(value, entry) {
                return entry['state.id'];
            })
            .perPage(0)
            .targetEntity(nga.entity('state').url('states'))
            .targetField(nga.field('name'))
            .singleApiCall(ids => null)
        );

    }
    if(HasRole('company')){
        fields.push(
            nga.field('prescriber_type.id', 'reference')
                .label('PRESCRIBER_TYPE')
                .map(function truncate(value, entry) {
                    return entry['prescriber_type.id'];
                })
                .targetEntity(nga.entity('prescriberType').url('prescriberTypes'))
                .targetField(nga.field('description'))
        );
    }
    entity.creationView().fields(fields)
        .onSubmitError(['error', 'form', 'progression', 'notification','$filter',  function(error, form, progression, notification, $filter) {
            $(':input').each(function(){
                $(this).closest('.form-field').removeClass('has-error').find('.help-block.error').remove();
            });

            error.data.fields.forEach(function(error, index){
                let input = $('[name='+error.property_path+']');
                $('<span class="help-block error">'+error.message+'</span>').insertAfter(input);
                input.closest('.form-field').addClass('has-error');
            });

            form['email'].$valid = false;

            progression.done();

            notification.log($filter('translate')(`INVALID_DETAILS_IN_FORM`), { addnCls: 'humane-flatty-error' });

            return true;
        }])
        .prepare(entity.showView().prepare());

    entity.editionView().fields(entity.creationView().fields())
        .onSubmitError(entity.creationView().onSubmitError())
        .prepare(entity.showView().prepare());

    entity.deletionView();

    return entity;
}


/** WEBPACK FOOTER **
 ** ./js/entities/company/config.js
 **/